import jump from 'jump.js';

// Get all triggers
const jumpElements = document.querySelectorAll('.js-optional-scroll');
const jumpElementsArr = Array.prototype.slice.call(jumpElements);

export default {
  /**
   * Loop through elements, and create event listeners for every element
   * @return {void}
   */
  initialize() {
    jumpElementsArr.forEach(this.createEvent.bind(this));
  },

  /**
   * Create event listener for the given element
   * @param  {Node}  el  Element to listen for clicks
   * @return {Void}
   */
  createEvent(el) {
    if (/^#/.exec(el.getAttribute('href'))) {
      el.addEventListener('click', (event) => {
        event.preventDefault();

        const target = el.getAttribute('href');
        const offset = -40;

        // Ensure that element exists
        if (!document.querySelector(target)) {
          return;
        }

        this.handleJump(target, offset);
      });
    }
  },

  /**
   * Jump to the target element with a optional offset
   * @param  {String} target Target selector
   * @param  {Number} offset Offset for the scroll (for fixed navigation bars etc.)
   * @return {Void}
   */
  handleJump(target, offset) {
    jump(target, {
      offset,
      a11y: false,
    });
  },
};
